export const API_URL =
  process.env.NODE_ENV === 'production'
    ? process.env.REACT_APP_API_URL_PROD
    : process.env.REACT_APP_API_URL_STAGING;
export const RESET_PASSWORD_URL = `${process.env.REACT_APP_TRAINER_BASE_URL}/new_password`;
export const CONSUMER_BASE_URL = process.env.REACT_APP_CONSUMER_BASE_URL;
export const CONSUMER_BASE_URL_STAGING = process.env.REACT_APP_CONSUMER_BASE_URL_STAGING;
